"use client";

import { Modal } from "antd";
import { useState, useImperativeHandle, forwardRef } from "react";

export interface PopupModalRef {
  open: () => void;
  close: () => void;
}

interface PopupModalProps {
  title?: string;
  children: React.ReactNode;
  onOk?: () => void;
  onCancel?: () => void;
}

const PopupModal = forwardRef<PopupModalRef, PopupModalProps>(
  ({ title, children, onOk, onCancel }, ref) => {
    const [visible, setVisible] = useState(false);

    useImperativeHandle(ref, () => ({
      open: () => setVisible(true),
      close: () => setVisible(false),
    }));

    return (
      <Modal
        title={title}
        open={visible}
        onOk={() => {
          onOk?.();
          setVisible(false);
        }}
        onCancel={() => {
          onCancel?.();
          setVisible(false);
        }}
        footer={null}
        centered
        width={414}
        styles={{
          content: {
            maxWidth: '414px'
          }
        }}
      >
        {children}
      </Modal>
    );
  }
);

PopupModal.displayName = "PopupModal";

export default PopupModal;